import React from "react";
import { Modal, Button } from "antd";
import dayjs from "dayjs";
import { DeleteOutlined } from "@ant-design/icons";

interface QRCodeModalProps {
  visible: boolean;
  onClose: () => void;
  table?: {
    id?: number;
    number: string;
    qrcode: string;
    created_at?: string;
    location: { name: string };
  };
  /**
   * Optional callback if you want to enable "Delete Table" functionality.
   * If not provided, the delete button will not be shown.
   */
  onDelete?: (tableId: number) => void;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({
  visible,
  onClose,
  table,
  onDelete,
}) => {
  // Handle download of the QR code image
  const handleDownload = () => {
    if (!table?.qrcode) return;
    const link = document.createElement("a");
    link.href = table.qrcode;
    link.download = `Table-${table.number}-QRCode.png`;
    link.click();
  };

  return (
    <Modal
      title="View QR Code"
      visible={visible}
      onCancel={onClose}
      footer={[
        // Only show "Delete Table" if onDelete & table.id are provided (user has permission)
        table?.id && onDelete && (
          <Button
            key="delete"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(table.id!)}
          >
            Delete Table
          </Button>
        ),
      ].filter(Boolean)} // Filter out falsy items (if there's no onDelete)
    >
      {table && (
        <div className="space-y-4">
          {/* Row: Table Number & Date Created */}
          <div className="flex justify-between">
            <div>
              <div className="text-gray-500">Table Number</div>
              <div className="font-bold">{table.number}</div>
            </div>
            <div>
              <div className="text-gray-500">Date Created</div>
              <div className="font-bold">
                {table.created_at
                  ? dayjs(table.created_at).format("DD - MM - YYYY")
                  : "N/A"}
              </div>
            </div>
          </div>

          {/* Row: Location */}
          <div>
            <div className="text-gray-500">Location</div>
            <div className="font-bold">{table.location.name}</div>
          </div>

          {/* QR Code */}
          <div className="flex flex-col items-center">
            <img
              src={table.qrcode}
              alt="QR Code"
              className="w-48 h-48 object-cover"
            />
            <Button type="link" onClick={handleDownload}>
              Download QR Code
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default QRCodeModal;
